<template>
  <ul class="left-page-navigation nav">
    <li class="left-page-navigation-item hamburger-item">
      <hamburger-button @click.prevent="toggleMenu" class="btn-icon btn-icon-border-black" :class="{ 'active': isActive }" :isActive="isActive"></hamburger-button>
    </li>
    <li class="left-page-navigation-item logo">
      <router-link :to="{ name: 'home', params: { lang: storeViewCode } }">
        <img :src="require('theme/assets/image/logo-thumb.svg')" alt="Brand logo" class="img-fluid" width="100"/>
      </router-link>
    </li>
    <!-- <li class="left-page-navigation-item my-card">
      <button class="btn btn-none btn-icon">
        <svg class="o-icon"><use xlink:href="#credit-card"></use></svg>
      </button>
    </li> -->
    <li class="left-page-navigation-item logout">
      <button class="btn btn-icon" @click.prevent="logout" :class="{ 'btn-none': !isActive, 'btn-icon-small btn-icon-border-black btn-rounded': isActive }">
        <svg class="o-icon"><use xlink:href="#exit"></use></svg>
      </button>
    </li>
    <li class="left-page-navigation-item user">
      <router-link :to="{ name: 'Boutique', params: { lang: storeViewCode, store_code: currentStoreCode } }">
        <svg class="o-icon"><use xlink:href="#user-line"></use></svg>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'LeftPageNavigation',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    storeViewCode () {
      return this.$store.state.ui.storeViewCode
    },
    currentStoreCode () {
      return this.$store.getters['userAdmin/getCurrentStoreCode']
    }
  },
  methods: {
    toggleMenu () {
      if (!this.isActive) {
        let componentToLoad = import('theme/components/Menu/HamburgerMenu')
        this.$store.dispatch('ui/loadLeftActiveComponent', { component: componentToLoad })
      } else {
        this.$emit('close-menu')
      }
    },
    logout () {
      this.$store.commit('ui/showLoader')
      return this.$store.dispatch('userAdmin/logout')
        .finally(() => {
          this.$store.commit('ui/hideLoader')
        })
    }
  },
  components: {
    HamburgerButton: () => import('theme/components/Header/HamburgerButton'),
    BrandLogo: () => import('theme/components/BrandLogo/BrandLogo')
  }
}
</script>
